var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LeftSide',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.title)+" ")]},proxy:true}])},[(_vm.report)?_c('ReportForm',{attrs:{"report":_vm.report}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }